<!-- WEB_4853 reveting popup for timeout and refresh token -->
<!-- <app-idle-timeout></app-idle-timeout> -->
<div class="accepted-devices--valid">
    <router-outlet></router-outlet>
</div>
<div class="accepted-devices--invalid">
    <h2>This web portal is not optimised to work below 320px screen width. Please view with a larger device.</h2>
</div>
